import { z } from 'zod';
export const aiModelPolicyTierSchema = z.enum(['simple', 'main', 'complex']);
export const aiModelPolicySlotSchema = z
    .object({
    modelId: z.string().min(1),
})
    .strict();
export const aiModelPolicySchema = z
    .object({
    simple: aiModelPolicySlotSchema,
    main: aiModelPolicySlotSchema,
    complex: aiModelPolicySlotSchema,
    fallback: aiModelPolicySlotSchema.nullable().optional(),
})
    .strict();
const CDLIT_PLATFORM_ROUTED_MODEL = ['platform', 'routed'].join('-');
export function isCdlitPlatformOwnedModelRef(ref) {
    return ref.provider === 'openrouter' && ref.model === CDLIT_PLATFORM_ROUTED_MODEL;
}
export function isCdlitPlatformOwnedModelId(modelId) {
    const slash = modelId.indexOf('/');
    if (slash <= 0)
        return false;
    if (modelId.slice(0, slash) !== 'openrouter')
        return false;
    return modelId.slice(slash + 1) === CDLIT_PLATFORM_ROUTED_MODEL;
}
function platformModelIdFromRef(ref) {
    const model = ref.model.trim();
    if (!model || isCdlitPlatformOwnedModelRef(ref))
        return undefined;
    if (model.includes('/'))
        return model;
    return undefined;
}
export function deriveModelPolicyFromLegacyRuntime(runtime) {
    if (isCdlitPlatformOwnedModelRef(runtime.primary)) {
        return undefined;
    }
    const primaryId = platformModelIdFromRef(runtime.primary);
    if (!primaryId) {
        return undefined;
    }
    const fallbackRef = runtime.fallback ?? null;
    const fallbackId = fallbackRef ? platformModelIdFromRef(fallbackRef) : undefined;
    const slot = { modelId: primaryId };
    return {
        simple: slot,
        main: slot,
        complex: slot,
        fallback: fallbackId ? { modelId: fallbackId } : null,
    };
}
export function resolveModelIdForComplexity(modelPolicy, tier) {
    return modelPolicy[tier].modelId;
}
export function resolveCdlitTextGatewayModelId(resolved, tier = 'main') {
    const policy = resolved.modelPolicy;
    if (!policy) {
        throw new Error('modelPolicy is required for CDLIT platform text completion');
    }
    return resolveModelIdForComplexity(policy, tier);
}
//# sourceMappingURL=model-policy.js.map